module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/new/store_images/1_a2249e09614c0d43406ec98493fcddeb.png";